import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import theme01Img from "../../assets/images/theme01.png";
import theme02Img from "../../assets/images/theme02.png";
import theme03Img from "../../assets/images/theme03.png";
import theme04Img from "../../assets/images/theme04.png";
import theme05Img from "../../assets/images/theme05.png";
import theme06Img from "../../assets/images/theme06.png";
import theme07Img from "../../assets/images/theme07.png";
import theme08Img from "../../assets/images/theme08.png";
import theme09Img from "../../assets/images/theme09.png";
import FadeIn from '../common/FadeIn';

const TemplateMarqueeSection = () => {
  const navigate = useNavigate();

  const templateCards = [
    { id: 1, img: theme01Img },
    { id: 2, img: theme02Img },
    { id: 3, img: theme03Img },
    { id: 4, img: theme04Img },
    { id: 5, img: theme05Img },
    { id: 6, img: theme06Img },
    { id: 7, img: theme07Img },
    { id: 8, img: theme08Img },
    { id: 9, img: theme09Img },
  ];

  const handleCardClick = (e) => {
    e.preventDefault();
    navigate('/websites');
  };

  return (
    <FadeIn>
      <section className="w-full bg-[#0D0C0B] pb-16 md:pb-24 overflow-hidden relative border-b border-white/10">
        <div className="w-full overflow-hidden relative z-10">
          <div className="animate-marquee gap-[14px] sm:gap-[18px] md:gap-8 px-2 sm:px-4">
            {templateCards.map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to="/websites"
                onClick={handleCardClick}
                className="group relative flex-shrink-0 marquee-card-size block cursor-pointer z-10"
              >
                <img
                  src={item.img}
                  alt={`Website Template Preview ${item.id}`}
                  className="w-full h-full object-cover object-top filter brightness-[0.95] pointer-events-auto"
                  loading="lazy"
                  decoding="async"
                  width="384"
                  height="512"
                />
              </Link>
            ))}
          </div>
        </div>
      </section>
    </FadeIn>
  );
};

export default TemplateMarqueeSection;
